import React from "react";

const IdleVehiclesDashboardLoadable = React.lazy(() => import("./IdleVehiclesDashboard"));
const IdleVehiclesApprovalLoadable = React.lazy(() => import("./IdleVehiclesApproval"));

export { 
    IdleVehiclesDashboardLoadable,
    IdleVehiclesApprovalLoadable,
};